/**
 * Les fabricants communs des formes parallèles (11/10/2026) : une question de forme est fixe (pas de tirage),
 * ses choix restent dans leur ordre, son tableau a le type que le quiz donne à l'officiel, et elle porte la
 * référence de son texte (support_lecture). Le script du back crée ces questions en base d'après les modules.
 */
import { basePayload, makeVraiFaux } from '../../utils';
import { avecSupportLecture } from '../../../utils/supportLecture';
import { typeDeTableau } from '../index';
import { COMPETENCES } from './competences';

const LETTRES = ['A', 'B', 'C', 'D'];
const optionsDu = (niveau) => ({ niveau: `${niveau}eme`, matiere: 'francais', attendu: null });

/** Espaces insécables : devant ; : ? ! % », après «, dans les nombres (4 000). */
export const typo = (s) => String(s)
    .replace(/ ([;:?!%»])/g, ' $1')
    .replace(/« /g, '« ')
    .replace(/(\d) (\d{3})/g, '$1 $2');

/** Un QCM dans l'ordre donné (pas de mélange) ; lève si la bonne réponse n'est pas l'un des choix. */
export const qcm = (niveau, support, enonce, choix, bonne, elements = []) => {
    const choixTypo = choix.map(typo);
    const i = choixTypo.indexOf(typo(bonne));
    if (i < 0) throw new Error(`Bonne réponse absente des choix : ${bonne}`);
    if (new Set(choixTypo).size !== choixTypo.length) throw new Error(`Deux choix identiques : ${enonce}`);
    const ea = elements.length > 0 ? { version: 1, elements } : null;
    return avecSupportLecture(
        basePayload('qcm', `<p>${typo(enonce)}</p>`, { choix: choixTypo, bonne_reponse: LETTRES[i] }, optionsDu(niveau), ea),
        support,
    );
};

/** Un tableau à cocher, une réponse par ligne (bonnes = l'indice de la colonne juste, ligne par ligne). */
export const tableau = (niveau, support, enonce, colonnes, lignes, bonnes, elements = []) => {
    if (lignes.length !== bonnes.length) throw new Error(`Une colonne juste par ligne : ${enonce}`);
    const payload = makeVraiFaux(lignes.map(typo), bonnes, `<p>${typo(enonce)}</p>`, {
        ...optionsDu(niveau),
        colonnes: colonnes.map(typo),
        elements_additionnels: { version: 1, elements },
    });
    const ea = payload.elements_additionnels;
    return avecSupportLecture({
        ...payload,
        elements_additionnels: {
            ...ea,
            elements: ea.elements.map((e) => (e.type === 'table' ? { ...e, config: { ...e.config, type: typeDeTableau(e.config) } } : e)),
        },
    }, support);
};

/**
 * Une question de forme : son numéro dans la forme, son numéro dans son texte (Q01…), sa compétence (et le
 * libellé de la famille, mot pour mot), et la clé de son générateur pour le back.
 */
export const question = ({ niveau, texte, numero, questionNum, competence, payload, ...autres }) => {
    if (!COMPETENCES[competence]) throw new Error(`Compétence inconnue : ${competence}`);
    return {
        questionNum,
        numero,
        competence,
        libelle: COMPETENCES[competence],
        ...autres,
        payload: { ...payload, _meta: { ...payload._meta, generatorKey: `parallele-2026:${niveau}:${texte}:${questionNum}` } },
    };
};
